export default "__VITE_ASSET__Dsqwgvgr__"